<template>
  <div id="home">
    <div class="homeWrap">
      <div class="logoTitle">
        <div  style="font-size:38px;display: flex;align-items: center">
          <div @click="goBack" style="cursor:pointer;">
            <v-icon name="regular/arrow-alt-circle-left" scale="2.2" style="color:white"></v-icon>
            <strong>返回首页</strong>
          </div>
          
        </div>
        
      </div>
      <div class="moduleWrap">
        <div class="moduleUp">
          <router-link class="linkA" to="/display">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="html5-c" scale="3.5"></v-icon>
              </div>
              <p>平台大数据</p>
            </div>
          </router-link>
          <router-link class="linkA"  to="" >
            <div class="moduleItem" @click="chooseOrgan">
              <div class="icon">
                <v-icon name="html5-c" scale="3.5"></v-icon>
              </div>
              <p>会员协会大数据</p>
            </div>
          </router-link>
          <router-link class="linkA" to="/display-teachers">
            <div class="moduleItem">
              <div class="icon">
                <v-icon name="html5-c" scale="3.5"></v-icon>
              </div>
              <p>讲师大数据</p>
            </div>
          </router-link>
        </div>
      </div>
      <select-organ :organList="organList" @hideTips="hideTips" :showdialog="showSelectOrganDialog"></select-organ>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons/list-alt";
import "vue-awesome/icons/university";
import "vue-awesome/icons/user-plus";
import "vue-awesome/icons/user-lock";
import "vue-awesome/icons/user-check";
import "vue-awesome/icons/sticky-note";
import "vue-awesome/icons/user-alt-slash";
import "vue-awesome/icons/file-archive";
import "vue-awesome/icons/sitemap";
import "vue-awesome/icons/clipboard-list";
import "vue-awesome/icons/users-cog";
import "vue-awesome/icons/chalkboard-teacher";
import "vue-awesome/icons/user-cog";
import "vue-awesome/icons/regular/file-alt";
import "vue-awesome/icons/check";
import "vue-awesome/icons/clipboard-check";  // file-signature
import "vue-awesome/icons/file-signature";
import "vue-awesome/icons/comment-alt"; // 提示气泡
import {tipsNum} from "@/api/system_manager/api";
import '../../assets/js/yioks-icons'
import fiveMixins from '@/minix/fiveMixins';
import {filtrate_data} from "@/api/ab_signup/api";

export default {
  name: "BigDataHome",
  mixins: [fiveMixins],
  data() {
    return {
      organList:[],
      showSelectOrganDialog:false,
    };
  },
    computed: {
    
    },
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "select-organ" :() => import('./select-organ')
  },
  filters: {
  
  },
  created() {
    this.getOrganList();
  },
  methods: {
    goBack(){
      this.$router.push('/sm')
    },
    chooseOrgan(){
      this.showSelectOrganDialog=true;
    },
    getOrganList(){
      filtrate_data({}).then(
        ({ data: { result, status } }) => {
          if (status === 0) {
            this.organList = result.organization;
          }
        }
      );
    },
    hideTips(bool){
      this.showSelectOrganDialog=false;
    },
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
#home
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  user-select none
  .homeWrap
    width 930px
    .logoTitle
      height 85px
      display block
      flex-direction column
      justify-content center
      align-items center
      margin 0 0 40px 0
      color $color_title
      font-size 40px
      font-weight bolder
      text-shadow 2px 1px 3px #231815
    .moduleWrap
      .moduleUp, .moduleDown, .module-item
        margin 40px 0
        display flex
        justify-content space-between
        box-sizing border-box
        .linkA
          // width: 200px;
          // flex: 1 1 auto;
          flex 1
          margin 0 20px
      .moduleItem
        position relative
        width 100%
        height 200px
        display flex
        flex-direction column
        justify-content center
        align-items center
        color $color_white
        font-size 23px
        background-color $block_bg_color_base
        cursor pointer
        .icon
          display flex
          align-items center
        p
          margin 20px 0 0
          font-size 20px
      .classItem
        .tips
          position absolute
          top calc(20% - 15px)
          right calc(35% - 15px)
          .icon
            color $color_suc
          .num
            width 100%
            height 100%
            padding 2px 0 0
            position absolute
            top 0
            left 0
            text-align center
            font-size $font_size_big
.bg
  background-color $block_bg_color_base
.animate
  flex-basis 2
.h200
  height 200px
.module-item
  display flex
  .tips
    position absolute
    top calc(20% - 15px)
    right calc(35% - 15px)
    .icon
      color $color_suc
    .num
      width 100%
      height 100%
      padding 2px 0 0
      position absolute
      top 0
      left 0
      text-align center
      font-size $font_size_big
  .item-wrapper
    flex 1
    height 200px
    display flex
    .linkA
      margin 0 20px
    .hover-box-hide
      margin 0 20px
      flex 1
    .hover-box-show
      display none
    &:hover
      .hover-box-show
        display flex
        flex 1
        justify-content space-between
      .hover-box-hide
        display none
.moduleDown
  display flex
  .tips
    position absolute
    top calc(20% - 15px)
    right calc(35% - 15px)
    .icon
      color $color_suc
    .num
      width 100%
      height 100%
      padding 2px 0 0
      position absolute
      top 0
      left 0
      text-align center
      font-size $font_size_big
</style>
